import React, { useEffect }                                           from 'react'
import {ActionProps}                                               from '../types'
import { SAMLAuthResponse, useRedirectToSAMLMutation }                                   from '../api/enrollement';
import { SAMLActionConfig } from '../types/SAMLActionConfig';
import { Spin } from 'antd';

const SAMLAction: React.FC<ActionProps<SAMLActionConfig>> = ({ config }) => {

  const [redirectToSAMLServer] = useRedirectToSAMLMutation()

  useEffect(() => {
    navigateToSAML()
  }, [])

  const navigateToSAML = () => {
    redirectToSAMLServer({
        samlProfileId: config.samlIdpProfileId
    }).then(response => {
        const SAMLResponse = response.data
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = location.origin.replace('enrollments.', '') + SAMLResponse?.authenticationUrl as string
        for (const key in SAMLResponse) {
          if (key === 'authenticationUrl') continue;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = SAMLResponse[key as keyof SAMLAuthResponse];
          form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
    })
  }

  return <Spin spinning={true} fullscreen data-testid='spinner' />
}

export default SAMLAction
